import type { ToolRouteConfig } from '../components/ToolRoutes/ToolRoutes';
import type { AppConfig, AppConfigV2 } from './types';

export function defineAppConfig<const Config extends AppConfig>(
  config: AppConfig extends Config ? Config : AppConfig,
): Config {
  return config as Config;
}

export const enum AppConfigVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export function isAppConfigV2(appConfig: AppConfig): appConfig is AppConfigV2 {
  return appConfig.version === AppConfigVersion.V2;
}

export function groupSubItemsBySections<T extends ToolRouteConfig>(
  subItems: readonly T[],
): Readonly<Record<string, readonly T[]>> {
  const grouped: Record<string, T[]> = {};

  for (const item of subItems) {
    const sectionKey = item.section?.key ?? 'unsectioned';
    (grouped[sectionKey] ??= []).push(item);
  }

  return grouped;
}
